/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'dashboard-analytics/filters/controls/NonNumericFilterController',
	'dashboard-analytics/filters/controls/NonNumericFilterModel',
	'jquery',
	'underscore'
], function (BaseClass, NonNumericFilterModel, $, _) {

	/**
	 * @class
	 * @classdesc The controller is for the flat list filter which is a simplified local filter without the conditions
	 */
	var NonNumericHighlightFilterController = BaseClass.extend({

		/**
		 * @override
		 */
		init: function(options) {
			this.id = _.uniqueId('NonNumericHighlightFilterController');
			this.dashboardApi = options.dashboardApi;
			this.pageContextApi = options.pageContextAPI;
			this.itemContext = options.itemContext;
			this.services = options.services;
			this.commonView = options.commonView;
			this.queryHelper = this._createQueryHelper();
			this.highlightAct = options.highlightAct;
			this.viewConfig = {
				commonView: this.commonView,
				services: this.services,
				dashboardApi: this.dashboardApi
			};
			this.filterSpec = options.filterSpec;
			this.resetSearch = false;
			this.lastFilterCondition = null;
			this.metadataInfo = this._getMetadataInfo(options);
		},

		/**
		 * @override
		 */
		_initializeExtraData: function () {},

		/**
		 * @override
		 */
		_createFilterModel: function() {
			var modelOptions = {
				name: this.itemContext.itemName,
				list: []
			};
			this.model = new NonNumericFilterModel(modelOptions);
		},

		/**
		 * @override
		 */
		render: function() {
			// hide invert button for timeline highlights. There is no plan for common filter control to implement hide invert button api
			return NonNumericHighlightFilterController.inherited('render', this, arguments).then(function() {
				this.commonView.$el.find('[data-tid = "invertSelectionClickable"]').hide();
			}.bind(this));
		},

		/**
		 * @override
		 */
		onDone: function() {
			var existingPayloadCopy = $.extend(true, [], this.highlightAct.payload);
			var options = {
				payloadData: {
					undoRedoTransactionId: _.uniqueId('highlight')
				}
			};
			if(this.model.getInvert()) {
				this.model.toggleSelectStateAll();
			}
			existingPayloadCopy.forEach(function(col) {
				if (col.columnId === this.filterSpec[0].columnId) {
					// reset values and operator
					col.values = [];
					delete col.operator;
					_.each(this.model.selectedMembers, function(member) {
						col.values.push({
							u: member.u,
							d: member.d
						});
						col.operator = 'in';
					});
				}
			}.bind(this));
			this.highlightAct.set({
				payload: existingPayloadCopy
			}, options);
			if (!this.view.isCompact) {
				this.view.remove();
			}
			if (this.commonView.remove) {
				this.commonView.remove();
			}
		},

		/**
		 * @override
		 * @description Override with no page context handling
		 */
		_refreshModel: function() {
			this.model.clearValues();
			this.model.setSelectedMembers(this.filterSpec[0].values);
		}
	});
	return NonNumericHighlightFilterController;
});
